export enum GateType {
  'H' = 'H',
  'X' = 'X',
  'Y' = 'Y',
  'Z' = 'Z',
  'S' = 'S',
  'T' = 'T',
  'I' = 'I',
}

export const gateTitleMap: { [key in GateType]: string } = {
  H: 'Hadamard gate',
  X: 'Pauli-X (NOT) gate',
  Y: 'Pauli-Y gate',
  Z: 'Pauli-Z gate',
  S: 'Phase gate',
  T: 'T gate',
  I: 'Identity gate (noop)',
}

export const gateLatexContent: { [key in GateType]: string } = {
  H: `H = \\frac{1}{\\sqrt{2}}\\begin{bmatrix}
    1 & 1 \\\\
    1 & -1 
    \\end{bmatrix}`,
  X: `X = \\begin{bmatrix}
  0 & 1 \\\\
  1 & 0 
  \\end{bmatrix}`,
  Y: `Y = \\begin{bmatrix}
  0 & -i \\\\
  i & 0 
  \\end{bmatrix}`,
  Z: `Z = \\begin{bmatrix}
  1 & 0 \\\\
  0 & -1 
  \\end{bmatrix}`,
  S: `S = \\begin{bmatrix}
  1 & 0 \\\\
  0 & i
  \\end{bmatrix}`,
  T: `T = \\begin{bmatrix}
  1 & 0 \\\\
  0 & e^{i\\pi/4}
  \\end{bmatrix}`,
  I: `I = \\begin{bmatrix}
  1 & 0 \\\\
  0 & 1
  \\end{bmatrix}`,
}
